import backgroundTextureLight from 'assets/images/vxl/component/productIntroScreen/background-texture-light.png';
import { NativeStackHeaderProps, Stack } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ImageSourcePropType, StyleSheet, View } from 'react-native';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import ProductIntroScreen from 'shared/patterns/vxl/ProductIntroScreen/ProductIntroScreen';
import theme from 'shared/styles/theme';

import Content from './Content';

const WhatIsVaroAdvance = () => {
  const { t: translatedText } = useTranslation('advance', {
    keyPrefix: 'whatIsVaStrings',
  });

  return (
    <View style={styles.screen}>
      <Stack.Screen
        options={{
          headerShown: true,
          headerBackVisible: true,
          headerTransparent: true,
          title: translatedText('title'),
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} transparent />
          ),
        }}
      />
      <ProductIntroScreen
        backgroundTexture={backgroundTextureLight as ImageSourcePropType}
        headlineText={translatedText('headLineText')}
        headlineTextStyle="expressive"
        bodyContent={<Content />}
        visual="ADVANCE_A"
        topPadding={80}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
});

export default WhatIsVaroAdvance;
